import React from 'react'

import { useSelector } from 'react-redux'

import CVDetails from '../../CVDetails'

const DefaultTemplate = ({ downloadRef }) => {
  const { wfh, applicantScorecard, showSpeedTest, remoteWorkEthics, backupInfrastructure } =
    useSelector((state) => state.modal)

  return (
    <CVDetails
      downloadRef={downloadRef}
      showSpeedTest={showSpeedTest}
      showWFH={wfh}
      showBackupInfrastructure={backupInfrastructure}
      showRemoteFitness={remoteWorkEthics}
      showScorecard={applicantScorecard}
    />
  )
}

export default DefaultTemplate
